import React from 'react';
import { Tabs, Tab, AppBar, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    appBar: {
        backgroundColor: 'transparent',
        color: 'black',
        boxShadow: 'none',
        marginTop: '40px'
    },
    tabs: {
        '& .MuiTabs-indicator': {
            backgroundColor: theme.palette.primary.main,
            height: 3,
        },
    },
    tab: {
        fontWeight: 500,
        '&.Mui-selected': {
            fontWeight: 700,
        },
    },
}));

const VehicleTabs = ({ onChange, value }) => {
    const classes = useStyles();

    return (
        <AppBar position="static" className={classes.appBar}>
            <Tabs
                value={value}
                onChange={onChange}
                indicatorColor="primary"
                textColor="inherit"
                className={classes.tabs}
                variant="fullWidth"
            >
                <Tab label="Territory" className={classes.tab} />
                <Tab label="Everest" className={classes.tab} />
                <Tab label="Explorer" className={classes.tab} />
                <Tab label="Ranger" className={classes.tab} />                
                <Tab label="Transit" className={classes.tab} />
                <Tab label="Mustang Mach-E" className={classes.tab} />
            </Tabs>
        </AppBar>
    );
};

export default VehicleTabs;